if (!customElements.get('board-connections')) {
  customElements.define('board-connections', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.details = [...this.querySelectorAll('[data-board-detail]')];
      this.points = [...this.querySelectorAll('[data-board-point]')];
      this.prompt = this.querySelector('[data-board-prompt]');
      this.status = this.querySelector('[data-board-status]');
      this.addEventListener('click', event => {
        if (event.target.closest('[data-board-close]')) {
          this.close();
          return;
        }
        const point = event.target.closest('[data-board-point]');
        if (!point) return;
        const detail = this.details.find(item => item.dataset.boardDetail === point.dataset.boardPoint);
        if (!detail) return;
        event.preventDefault();
        this.select(this.activeDetail === detail ? null : detail);
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape' || !this.activeDetail) return;
        event.preventDefault();
        event.stopPropagation();
        this.close();
      }, options);
      document.addEventListener('shopify:block:select', event => {
        const detail = event.target.closest('[data-board-detail]');
        if (detail && this.contains(detail)) this.select(detail);
      }, options);
      this.select(null);
    }

    select(detail) {
      this.activeDetail = detail;
      this.details.forEach(item => {
        item.setAttribute('aria-hidden', String(item !== detail));
        item.inert = item !== detail;
      });
      this.prompt?.setAttribute('aria-hidden', String(Boolean(detail)));
      const active = detail?.dataset.boardDetail;
      this.points.forEach(point => {
        point.setAttribute('aria-expanded', String(point.dataset.boardPoint === active));
        if (point.dataset.boardPoint === active) point.setAttribute('aria-current', 'true');
        else point.removeAttribute('aria-current');
      });
      if (this.status) {
        this.status.textContent = detail
          ? [...detail.querySelectorAll('[data-board-title], [data-board-text]')].map(item => item.textContent.trim()).join('. ')
          : '';
      }
    }

    close() {
      const point = this.points.find(item => item.dataset.boardPoint === this.activeDetail?.dataset.boardDetail);
      this.select(null);
      point?.focus({ preventScroll: true });
    }

    disconnectedCallback() { this.events?.abort(); }
  });
}
